import React, { useState } from 'react';
import { Link } from '@inertiajs/inertia-react';
import Layout from '../Shared/Layout';
import ListView from '../Components/ListView';
import { BiSearch } from 'react-icons/bi';
import { Inertia } from '@inertiajs/inertia';

const Search = ({query, searchResults}) => {
    console.log(query, searchResults);

    const [searchQuery, setSearchQuery] = useState(query);
    const handleSubmit = (e) => {
        e.preventDefault();
        Inertia.get(`/on-demand/search`, { query: searchQuery, preserveState: true });
    }

    return (
        <>
            <div className="container" data-theme="jpm">
                <div className="row mb-5 mt-4">
                    <div className="col-12">
                        <form onSubmit={handleSubmit}>
                            <p className="text-xs text-neutral-content grow-0 uppercase">Search Results for</p>
                            <div className="w-auto flex flex-row justify-between items-center">
                                <input type="text" name="query" value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)}
                                    className="input p-0 grow focus:outline-0 focus:border-primary
                                    border-x-0 border-t-0 rounded-none border-b border-solid border-[#e0e0e0] w-auto text-2xl font-bold" />
                                <button type="submit"><BiSearch size="32px" /></button>
                            </div>
                        </form>
                    </div>
                </div>
                {searchResults.length == 0 ?
                    <div className="row mb-5 mt-4">
                        <div className="col-12">
                            Sorry, there are no search results for {query}. Please try another keyword.
                        </div>
                    </div>
                : searchResults.map((channelItems,index) =>
                    <ListView  
                        key={index}
                        showPartNumber={true}
                        header={channelItems[0].channelTitle}
                        items={channelItems}
                        hideSeeAll={true} />   
                )}
            </div>
        </>
    )
}

// Persistent layout Docs: https://inertiajs.com/pages#persistent-layouts
Search.layout = page => <Layout title="Search" children={page} data-theme="jpm"/>;

export default Search;
